import type {
  ICreateMinerFamilyPricingForm,
  ICustomerMinerFamilyPricing,
  IMinerFamilyPricingFilters,
  IMinerFamilyPricingHistoryFilters,
  IMinerModelFamilyPricing,
  IMinerModelFamilyPricingHistory,
} from '@/types/asicw/pricings'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

// customers/pricings

/**
 * Retrieves the pricing sets for miner families
 */
export async function getCustomersMinerFamilyPricings(
  filters: IMinerFamilyPricingFilters
): Promise<IPage<ICustomerMinerFamilyPricing>> {
  const res = await axios.get(import.meta.env.VITE_APP_ASICW_CUSTOMERS_PRICINGS_ENDPOINT, { params: filters })
  return res.data
}

// /pricings

/**
 * Retrieves the pricing sets for miner families
 */
export async function getMinerFamilyPricings(
  filters: IMinerFamilyPricingFilters
): Promise<IPage<IMinerModelFamilyPricing>> {
  const res = await axios.get(import.meta.env.VITE_APP_ASICW_PRICINGS_ENDPOINT, { params: filters })
  return res.data
}

/**
 * Creates a pricing set for a miner family
 */
export async function createMinerFamilyPricing(
  pricingForm: ICreateMinerFamilyPricingForm
): Promise<ICreateMinerFamilyPricingForm> {
  const res = await axios.post(import.meta.env.VITE_APP_ASICW_PRICINGS_ENDPOINT, pricingForm)
  return res.data
}

// /pricings/:id

/**
 * Gets a pricing set's details
 */
export async function getMinerFamilyPricing(id: number): Promise<IMinerModelFamilyPricing> {
  const res = await axios.get(`${import.meta.env.VITE_APP_ASICW_PRICINGS_ENDPOINT}/${id}`)
  return res.data
}

/**
 * Updates a pricing set's details
 */
export async function updateMinerFamilyPricing(
  id: number,
  pricingForm: ICreateMinerFamilyPricingForm
): Promise<IMinerModelFamilyPricing> {
  const res = await axios.put(`${import.meta.env.VITE_APP_ASICW_PRICINGS_ENDPOINT}/${id}`, pricingForm)
  return res.data
}

/**
 * Gets a pricing set's details
 */
export async function deleteMinerFamilyPricing(id: number): Promise<IMinerModelFamilyPricing> {
  const res = await axios.delete(`${import.meta.env.VITE_APP_ASICW_PRICINGS_ENDPOINT}/${id}`)
  return res.data
}

// /pricings/:id/history

/**
 * Retrieves a pricing set's history
 */
export async function getMinerFamilyPricingHistory(
  id: number,
  filters: IMinerFamilyPricingHistoryFilters
): Promise<IPage<IMinerModelFamilyPricingHistory>> {
  const res = await axios.get(`${import.meta.env.VITE_APP_ASICW_PRICINGS_ENDPOINT}/${id}/history`, { params: filters })
  return res.data
}
